
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wearable-app-development",
      function () {
        return require("private-next-pages/wearable-app-development/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wearable-app-development"])
      });
    }
  